"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includesObjectId = void 0;
/**
 * Checks if a given array of ObjectIds contains a certain ObjectId.
 */
function includesObjectId(array, objectId) {
    return array.findIndex((id) => id.equals(objectId)) >= 0;
}
exports.includesObjectId = includesObjectId;
